import { render, staticRenderFns } from "./ReferenceChangeView.vue?vue&type=template&id=1e2f5d08&scoped=true&"
import script from "./ReferenceChangeView.vue?vue&type=script&lang=ts&"
export * from "./ReferenceChangeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f5d08",
  null
  
)

export default component.exports